// extracted by css-extract-rspack-plugin
export default {"root":"hAjuS5","label":"sxlOdf","updated-ui":"GMsJOK","updatedUi":"GMsJOK"};